import React, {Component} from 'react';
import { inject, observer } from 'mobx-react';

import { Select, Upload, Button, Icon } from 'antd';
import AirModal from '../../../../../common/components/AirModal';
import AirButton from '../../../../../common/components/AirButton';
import AirInput from "../../../../../common/components/AirInput";
import AirSelectWithLabel from "../../../../../common/components/AirSelectWithLabel";
import './CreateOrder.css';

const { Option } = Select;

@inject('translationsStore', 'ordersStore', 'commonStore')
@observer
export default class CreateOrder extends Component
{
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
	    fileList: []
    };
  }

  show = () => {
    const { ordersStore } = this.props;
    ordersStore.loadAvailableVehicles();
    this.setState({ visible: true, fileList: [] });
  };

  hide = () => {
    this.setState({
      visible: false,
      carId: undefined,
      externalOfferId: undefined,
      externalOrderId: undefined,
      description: undefined,
      fileList: []
    });
  };

  onVehicleChange = vehicle => {
    this.setState({ carId: vehicle });
  };

  setDescription = e => {
    this.setState({ description: e.target.value });
  };

  onSubmit = () => {
    const { carId, externalOfferId, externalOrderId, description, fileList } = this.state;
    const { commonStore, ordersStore } = this.props;

    this.hide();
    commonStore.setLoading(true);
    ordersStore.create(carId, externalOfferId, externalOrderId, description, fileList).then(() => {
      commonStore.setLoading(false);
    });

  }

  uploadFileCreate = file => {
    this.setState(state => ({
      fileList: [...state.fileList, file],
      }));
    return false;
  };
  
  uploadFileRemove = file => {
    const newFileList = [];
    this.state.fileList.forEach(file => {
      if (file.status !== 'removed') {
      newFileList.push(file);
      }
    });
    this.setState(state => ({
    fileList: newFileList
    }));
  };

  render() {
    const { translationsStore, ordersStore } = this.props;
    const { visible, carId, externalOfferId, description, fileList } = this.state;

    const availableVehicles = ordersStore.availableVehicles;
    const disabled = !carId;

    return (
      <AirModal
        className="CreateOrderModal"
        width='840px'
        visible={visible}
        title={translationsStore.translate('order.createOrder.modal.title')}
        onCancel={this.hide}
        okButton={<AirButton disabled={disabled} size="large" light="true" label={translationsStore.translate('order.createOrder.modal.buttonLabel')} />}
        onOk={() => !disabled && this.onSubmit()}
      >
        <AirSelectWithLabel
          style={{ marginBottom: '10px' }}
          label={translationsStore.translate('order.createOrder.modal.vehicle')}
          onChange={this.onVehicleChange}
          value={carId}
          dropdownMatchSelectWidth={false}
        >
          {availableVehicles.map(vehicle => (
            <Option key={vehicle.key} value={vehicle.key}>
              {vehicle.title} - {vehicle.description}
            </Option>
          ))}
        </AirSelectWithLabel>
        <AirInput label={translationsStore.translate('order.createOrder.modal.externalOfferId')} value={externalOfferId} onChange={(e) => this.setState({externalOfferId: e.target.value})} />
        <AirInput label={translationsStore.translate('order.createOrder.modal.description')} 
          textarea
              value={description}
              onChange={this.setDescription}
              maxlength="500"
              autosize={{ minRows: 2, maxRows: 2 }}
        />
        <Upload
						name="file"
						beforeUpload={this.uploadFileCreate}
						onRemove={this.uploadFileRemove}
						fileList={fileList}
					>
						<Button>
							<Icon type="upload" /> {translationsStore.translate('order.createOrder.modal.upload.placeholder')}
						</Button>
					</Upload>
      </AirModal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/OrdersManagerDashboard/SubHeader/CreateOrder/CreateOrder.js